import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { NotificationService } from "../services/notification.service";
import { SKIP_ERROR_TOAST } from "./http-context";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private notificationService: NotificationService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error) => {
        if (!request.context.get(SKIP_ERROR_TOAST)) {
          if (error instanceof HttpErrorResponse) {
            this.handleHttpError(error);
          } else if (error?.message?.includes("tempo limite")) {
            this.notificationService.showAlertMessage(error.message);
          }
        }
        return throwError(() => error);
      }),
    );
  }

  private handleHttpError(error: HttpErrorResponse): void {
    if (error.status === 0) {
      this.notificationService.showAlertMessage(
        "Não foi possível conectar ao servidor. Verifique sua conexão.",
      );
      return;
    }

    if (error.status === 404) {
      return;
    }

    if (error.status >= 500) {
      this.notificationService.showAlertMessage(
        "Houve uma instabilidade momentânea, tente novamente.",
      );
      return;
    }

    if (error.message?.includes("tempo limite")) {
      this.notificationService.showAlertMessage(error.message);
    }
  }
}
